import { render } from "./b-article.vue?vue&type=template&id=18e008ea&scoped=true"
import script from "./b-article.vue?vue&type=script&lang=js"
export * from "./b-article.vue?vue&type=script&lang=js"

import "./b-article.vue?vue&type=style&index=0&id=18e008ea&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e008ea"]])

export default __exports__